import { PbxHttpClient } from "../httpclient";

export const getOwnQueues = async () => {
  try {
    const { data } = await PbxHttpClient.get("/me_queue/");
    return data;
  } catch (err) {
    console.log("error fetching queues:", err);
  }
};
